import Vue from 'vue';
import router from '../router';

export default {
    state:{
      nombre:'',
      email:'',
      estatus:1,
      foto:'',
      uid:null
    },
    mutations: {
      setUsuario(state,usuario){
        state.nombre=usuario.displayName;
        state.email=usuario.email;
        state.foto=usuario.photoURL;
        state.uid=usuario.uid;
        var estatus = 1;
        if (usuario.disabled) {
          estatus=2;
        }
        state.estatus=estatus;
      }
    },
    actions: {
      loginUsuario(context,usuario){
        console.log(context);
        context.commit('setUsuario',usuario);
        context.dispatch('getPerfil');
      },
      logoutUsuario(context){
        context.commit('setUsuario',{
          nombre:'',
          email:'',
          estatus:1,
          foto:'',
          uid:null,
          id:null
        });
      },
    },
    getters: {  
      getUsuario(state){
        return state;
      }
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/usuario.js